export class TransactionAmountValueConverter {
    toView(value: number): string {
        return value ? `$${value.toFixed(2)}` : "";
    }
}

